import Route from '@ember/routing/route';
import type Controller from '@ember/controller';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';
import type SessionContextService from 'tio-employee/services/session-context';

export default class ProfileRoute extends Route {
  @service declare store: Store;
  @service sessionContext!: SessionContextService;

  resetController(controller: Controller, isExiting: boolean) {
    if (isExiting) {
      controller.set('parentDashboard', undefined);
    }
  }

  async model() {
    if (this.sessionContext.isFamilyMember) {
      const personId = this.sessionContext.person?.id;

      if (!personId) {
        throw new Error('Person ID is missing');
      }

      const { content: personContent } = (await this.store.request(
        findRecord<PersonModel>('person', personId, {
          reload: true,
          include: ['phone-numbers', 'user.logins'],
        })
      )) as { content: { data: PersonModel } };

      return { familyPerson: personContent.data };
    }

    const employeeId = this.sessionContext.currentEmployee.id || '';
    const { content: employeeContent } = (await this.store.request(
      findRecord<EmployeeModel>('employee', employeeId, {
        reload: true,
        include: [
          'phone-numbers',
          'person.user.logins',
          'dependents.person.user.logins',
          'company.company-setting',
        ],
      })
    )) as { content: { data: EmployeeModel } };

    return { employee: employeeContent.data };
  }
}
